import { StripeCardTypes } from '@givebacks/api/core';
import { TransformedValues, UseFormReturnType } from 'ui/Form';

import { TokenExCardTranslations } from '../../../../hooks/TokenEx/utils';

type StripeCardFormValues = {
  card_type: '' | StripeCardTypes;
  shouldSaveCard: boolean;
  zipCode?: string;
  stripeComplete: boolean;
  token: string | null;
};

type StripeCardFormTransValueResult =
  | {
      token: string;
      card_type: StripeCardTypes;
      shouldSaveCard: boolean;
      error: undefined;
    }
  | {
      error: {
        message: string;
      };
      token?: never;
      card_type?: never;
      shouldSaveCard?: never;
    };

type StripeCardFormTransformedValues = (
  values: StripeCardFormValues
) => Promise<StripeCardFormTransValueResult>;

type StripeCardForm = UseFormReturnType<StripeCardFormValues, StripeCardFormTransformedValues>;

type StripeCVVForm = {
  token: string;
};
type StripeCVVFormValuesReturnType = TransformedValues<UseFormReturnType<StripeCVVForm>>;
type StripeCVVFormTransformedValues = (values: StripeCVVFormValuesReturnType) => Promise<{
  token: string | null;
}>;

const STRIPE_TO_TOKENEX_CARD_TYPE_MAP: Record<StripeCardTypes, TokenExCardTranslations> = {
  Visa: TokenExCardTranslations.visa,
  MasterCard: TokenExCardTranslations.masterCard,
  'American Express': TokenExCardTranslations.americanExpress,
  Discover: TokenExCardTranslations.discover,
  'Diners Club': TokenExCardTranslations.diners,
  JCB: TokenExCardTranslations.jcb,
  UnionPay: TokenExCardTranslations.unionPay,
  Unknown: TokenExCardTranslations.unknown,
};

export { STRIPE_TO_TOKENEX_CARD_TYPE_MAP };
export type {
  StripeCardForm,
  StripeCardFormTransformedValues,
  StripeCardFormValues,
  StripeCVVForm,
  StripeCVVFormTransformedValues,
};
